import * as Yup from 'yup';

export const getAddDocumentSchema = () => {
  return Yup.object().shape({
    tags: Yup.array()
      .of(Yup.string())
      .min(1, 'At least one tag is required')
      .required('Tags are required')
      .test('unique', 'Tags must be unique', (value) => {
        if (!value) return true; // handled by required
        const lowerCased = value.map((v) => v?.toLowerCase?.().trim?.());
        return new Set(lowerCased).size === lowerCased.length;
      }),
    documentType: Yup.string().required('Document Type is required'),
    documents: Yup.array()
      .max(3, 'Maximum 3 documents allowed')
      .test('maxFiles', 'Maximum 3 documents allowed', (value) => {
        if (value && value.length > 3) {
          return false;
        }
        return true;
      })
      .min(1, 'At least one document is required')
      .required('Documents are required'),
  });
};
export const getEditDocumentSchema = () => {
  return Yup.object().shape({
    id: Yup.string(),
    name: Yup.string().required('File Name is required'),
    tags: Yup.array()
      .of(Yup.string())
      .min(1, 'At least one tag is required')
      .required('Tags are required')
      .test('unique', 'Tags must be unique', (value) => {
        if (!value) return true; // handled by required
        const lowerCased = value.map((v) => v?.toLowerCase?.().trim?.());
        return new Set(lowerCased).size === lowerCased.length;
      }),
  });
};
